import React from "react";
import { Button } from "reactstrap";
function DegreeToggle({ id, isVerified, degreeName, submit }) {
  return (
    <div>
      <Button
        color={isVerified ? "primary" : "danger"}
        className={isVerified ? "pe-4 btn-sm" : "btn-sm"}
        onClick={() =>
          submit({
            degreeId: id,
            degreeName: degreeName,
            isVerified: !isVerified,
          })
        }
      >
        {isVerified ? "Is Verified" : "Not Verified"}
      </Button>
    </div>
  );
}

export default DegreeToggle;
